import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import * as fromServices from '../app/services';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import * as fromComponents from './components';
import * as fromInterceptor from './interceptors/app.interceptor';
import { TemplateService } from './services/template/template.service';

@NgModule({
  declarations: [
    fromComponents.NoteToHrsaComponent,
    fromComponents.AboutThisToolComponent,
    fromComponents.AboutOrganTransportComponent,
    fromComponents.AboutMigrantsSeasonalToolComponent,
    fromComponents.AboutHivToolComponent,
    fromComponents.ExternalLinkDisclaimerComponent,
    fromComponents.ModalComponent,
    fromComponents.FindAHealthCenterComponent,
    fromComponents.HdwFooterComponent,
    fromComponents.HdwHeaderComponent,
    fromComponents.PaginatorComponent,
    fromComponents.ResourceContentComponent,
    fromComponents.MapContainerComponent,
    fromComponents.LoaderComponent,
    fromComponents.FilterByComponent,
    fromComponents.PdfExportComponent,
    fromComponents.ResourceContentItemsComponent,
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [CommonModule, AppRoutingModule, BrowserModule, FormsModule, ReactiveFormsModule, RouterModule],
  providers: [
    fromServices.ModalService,
    fromServices.ToolIdentifierService,
    fromServices.NameSuggestionService,
    fromServices.GeoLocationService,
    fromServices.HealthCenterLocationsService,
    fromServices.HccnLocationsService,
    fromServices.ImmigrantLocationsService,
    fromServices.OrganTransplantLocationsService,
    fromServices.RyanWhiteLocationsService,
    fromServices.FilterService,
    fromServices.LocationFactoryService,
    fromServices.LocationStateService,
    fromServices.ApiEnvironmentService,
    fromServices.ApiBuilder,
    fromServices.NotificationService,
    TemplateService,
    fromInterceptor.APP_INTERCEPTORS_LIST,
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ]
})
export class AppModule {}
